import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import React, { FC } from "react";
import Table from "./components/Table";
import {
  vendorColumns,
  mobileVendorColumns,
  wholeHomeMaintenance
} from "./constants";

import styles from "./styles.module.scss";

const Vendors: FC = () => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label className={styles.title} variant="h2-centered" color="primary">
        You&apos;ll have access to vendors suited for your needs
      </Label>
      <Label className={styles.subtitle} variant="s2-centered" color="primary">
        Humming Homes pre-vets all vendors; our vendors are bonded and insured,
        go through extensive background checks, and submit their
        before-and-afters, as part of our vetting process.
      </Label>
      <Media at={["desktop", "tablet"]}>
        <Table columns={vendorColumns} />
      </Media>
      <Media at={["mobile"]}>
        <Table columns={mobileVendorColumns} />
        <div className={styles.wholeHomeMaintenance}>
          <wholeHomeMaintenance.Icon className={styles.icon} />
          <Label color="secondary" variant="centered-body">
            {wholeHomeMaintenance.name}
          </Label>
        </div>
      </Media>
    </Content>
  );
};

export default Vendors;
